import { render, staticRenderFns } from "./changeLog.vue?vue&type=template&id=fe190fda&"
import script from "./changeLog.vue?vue&type=script&lang=js&"
export * from "./changeLog.vue?vue&type=script&lang=js&"
import style0 from "./changeLog.vue?vue&type=style&index=0&id=fe190fda&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QInnerLoading,QCardSection,QSpace,QBtn,QList,QExpansionItem,QItem,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QInnerLoading,QCardSection,QSpace,QBtn,QList,QExpansionItem,QItem,QIcon})
